<div>
    <div *ngIf="!ADRFormGroup.valid">
        <p style="color:red;padding-left: 25%;">shipment cant be updated becuse of missing infomation on adr</p>
    </div>
    <p-table #adrTable [value]="GetADRFormControls.controls" dataKey="RowId">
        <ng-template pTemplate="header">
            <tr>
                <th>{{'DANGEROUSGOODSTABLEHEADER.TEXT' | translate}}</th>
                <th>{{'DANGEROUSGOODSTABLEHEADER.CODE' | translate}}</th>
                <!-- <th>{{'DANGEROUSGOODSTABLEHEADER.LIQUIDVOLUME' | translate}}</th> -->
                <th>{{'DANGEROUSGOODSTABLEHEADER.SOILDVOLUME' | translate}}</th>
                <th>{{'DANGEROUSGOODSTABLEHEADER.POINTS' | translate}}</th>
                <th>LQ</th>
                <!-- <th style="width:8rem"></th> -->
                <th>
                    <i *ngIf="false && editable && !holding" style="cursor: pointer; color:var(--green-500);" class="pi pi-plus"
                       pTooltip="{{'DANGEROUSGOODSTABLEHEADER.ADDADR' | translate}}" tooltipPosition="left"
                       (click)="AddADRLine()"></i>
                    <p-progressSpinner *ngIf="holding" styleClass="spinner-overlay" strokeWidth="4"
                                       animationDuration=".5s" [style]="{ width: '2.5rem', height: '2.5rem' }">
                    </p-progressSpinner>


                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-line let-editing="editing" let-ri="RowId">
            <tr [formGroup]="line" [pEditableRow]="line">
                <td>
                    <p class="pi pi-info" pTooltip="samlet volume skal være over 0 (Kilo + Liter)"
                       style="color:var(--primary-color)" *ngIf="line.hasError('volumeInvalid')"> </p>
                    <p-cellEditor>

                        <ng-template pTemplate="input" required>
                            <p-autoComplete formControlName="SelectedAdr" (onSelect)="SetAdrCodeOnForm($event,line)"
                                            [suggestions]="foundAdrs" [minLength]="2" inputId="adr" [field]="'waybillString'"
                                            (completeMethod)="adrSearch($event)" [showEmptyMessage]="true"
                                            emptyMessage="{{'NOADRFOUND' | translate}}">
                                <ng-template let-adr pTemplate="adr">
                                    <div class="adr-item">
                                        <span>{{adr.waybillString}}</span>
                                    </div>
                                </ng-template>

                            </p-autoComplete>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{line.controls.SelectedAdr.value?.waybillString ?? "tryk for at vælge"}}
                        </ng-template>

                    </p-cellEditor>
                </td>
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" formControlName="AdrCode">
                        </ng-template>
                        <ng-template pTemplate="output">{{line.controls.SelectedAdr.value?.unNumber}}</ng-template>
                    </p-cellEditor>
                </td>

                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText formControlName="ADRSoildVolume" type="number">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{line.controls.ADRSoildVolume.value ?? 0}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td>
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText formControlName="Points" type="number">
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{line.controls.Points.value}}
                        </ng-template>
                    </p-cellEditor>

                </td>
                <td>{{line.controls.lowQuantity.value == true ? "LQ" : ""}}</td>
                <td>
                    <!-- <p-inputSwitch formControlName="lowQuantity"></p-inputSwitch> -->
                    <i *ngIf="line.controls.lowQuantaty" class="pi pi-check"></i>
                </td>
                <td style="text-align:center">
                    <i *ngIf="editable && false" style="cursor:pointer; color:var(--primary-color);" class="pi pi-trash"
                       [pTooltip]="('REMOVE' | translate) + ' UN ' + line.controls.SelectedAdr.value?.unNumber "
                       tooltipPosition="left" (click)="RemoveAdrFromShipment(line)"></i>

                    <!-- <button pButton pRipple type="button" icon="pi pi-trash" (click)="onRowEditCancel(line)" style="color:var(--primary-color);"></button> -->
                </td>
            </tr>

        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td>totaler:</td>
                <td colspan="1"></td>
                <!-- <td>{{GetLiquneTotalSum()}} liter</td> -->
                <td>{{GetSolidTotalSum() + " " + ('DANGEROUSGOODSTABLEHEADER.SOILDVOLUME' | translate)}}</td>
                <td>{{GetTotalPointSum() + " " + ('DANGEROUSGOODSTABLEHEADER.POINTS' | translate)}}</td>
                <td colspan="1"></td>
                <!-- <td colspan="1"></td> -->
            </tr>
        </ng-template>
    </p-table>
</div>